module.exports = __webpack_public_path__ + "img/hand.55c6a90f.png";